module.exports = __webpack_public_path__ + "img/fanyuexp.224a418c.jpg";